// import divertical from '../images/Divertical.webp'
// import divertical2 from '../images/Divertical2.webp'
// import efa from '../images/EFA.webp'
// import efa2 from '../images/EFA2.webp'
import film from '../images/LISTFILLM.png'
import film2 from '../images/film2.png'
import one from '../images/1.jpg'
import two from '../images/2.jpg'
import three from '../images/3.jpeg'
import four from '../images/4.jpg'
import bkg from '../images/BKG.png'
import trvl from '../images/Thumbnail - Travel Agency by Shineeee.jpg'
import trvl2 from '../images/TAMNEL.png'
import caper from '../images/caper.png'
import caper2 from '../images/caper2.png'

export const projects = [
    {
        id: 1,
        img: bkg,
        title: 'Rock Paper Scissors Mini Game',
        img2: bkg,
        distort: one,
        type: 'Web',
        link: 'https://bkg.vercel.app'
    },
    {
        id: 2,
        img: trvl,
        title: 'Travel Agency Landing Page and Mobile App',
        img2: trvl2,
        distort: two,
        type: 'UI Design',
        link: 'https://www.figma.com/@sultansyaefulmi'
    },
    {
        id: 3,
        img: film,
        title: 'List Film API',
        img2: film2,
        distort: three,
        type: 'Web',
        link: 'https://moviesaltun.vercel.app'
    },
    {
        id: 4,
        img: caper,
        title: 'Travelling Documentation Web App',
        img2: caper2,
        distort: four,
        type: 'Web',
        link: 'https://github.com/Shinee000ZZZ/CaPer'
    },
    // {
    //     id: 5,
    //     img: efa,
    //     title: 'Football Association',
    //     img2: efa2,
    //     distort: one,
    //     type: 'Web Design',
    //     link: 'https://www.behance.net/gallery/120495377/European-Football-Association-Webdesign-Concept'
    // }
]
